import React, { FC } from 'react';
import { GetSelectedDriversForJob_getSelectedDriversForJob as SelectedDrivers } from '../../../types/schemaTypes';
import { useLazyLoading } from '../../_common';
import SelectedDriverItem from './SelectedDriverItem';
import {  ToastContainer, toast } from 'react-toastify';
interface SelectedDriversListProps {
    selectedDrivers: SelectedDrivers[];
    refetch?: () => void;
    refetched: boolean;
    setRefetched: React.Dispatch<React.SetStateAction<boolean>>;
    isLoading: boolean;
    canEditDriversInDriverPool: boolean;
    isEndOfResults: boolean;
    onLoadMore: () => void;
    onDelete?: (record: any) => void;
    onSaveNotes: (selectedDriver: SelectedDrivers) => void;
}

const SelectedDriversForPoolList: FC<SelectedDriversListProps> = ({
    selectedDrivers,
    refetch,
    refetched,
    setRefetched,
    isLoading,
    isEndOfResults,
    onLoadMore,
    canEditDriversInDriverPool,
    onDelete,
    onSaveNotes,
}: SelectedDriversListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('selectedDriversForPoolList', isLoading, isEndOfResults, onLoadMore);
   
    if (refetched && refetch) {
        refetch();
      
        setRefetched(false);
    }

    return (
        <div className="SelectedDriversForPool-List" onScroll={handleScroll}>
            {/* <ToastContainer /> */}
            {selectedDrivers?.map((driver, index) => (
                <SelectedDriverItem
                    key={driver.driverId ? driver.driverId.toString() : '0'}
                    index={index}
                    canEditDriversInDriverPool={canEditDriversInDriverPool}
                    selectedDriver={driver}
                    onDelete={onDelete}
                    onSaveDriverNotes={onSaveNotes}
                ></SelectedDriverItem>
            ))}
        </div>
    );
};

export default SelectedDriversForPoolList;

